export const PIEVE_MCP_ACTIONS_EXECUTE_TOOL_NAME = 'pieve_mcp_actions_execute';
export const EXECUTE_VIRTUAL_ENV_TOOL_NAME = 'execute_virtual_env';
export const THREAD_ARTIFACT_SURFACE = 'threadArtifact';
export const SUPPORTED_GENERATED_RESULT_FORMATS = Object.freeze(['json', 'csv', 'xlsx', 'pdf', 'docx', 'txt', 'md']);
